import { createContext, useContext } from "react";
import axios from "axios";
import api from "@/lib/api";
import { downloadFile } from "@/lib/download";

const adminSource = {
  get: (path, config) => api.get(path, config),
  download: (url, filename) => downloadFile(url, filename),
  readOnly: false,
  visible: () => true,
};

const SHARE_PATHS = {
  "/erp/sales/trend": "/sales/trend",
  "/erp/outstanding/summary": "/outstanding/summary",
  "/pnl/summary": "/reports/summary",
  "/sections/expenses": "/expenses",
  "/sections/cogs": "/cogs",
};

export const shareClient = (lid) =>
  axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api/share/${lid}`, withCredentials: true });

/** Data source for the full-screen viewer: every request is scoped to the link and the picked company (vc). */
export function makeShareSource(lid, info, vc, onAccessLost) {
  const client = shareClient(lid);
  client.interceptors.response.use((r) => r, (err) => {
    if ([401, 410].includes(err.response?.status)) onAccessLost();
    return Promise.reject(err);
  });
  const map = (p) => {
    const [path, qs] = p.split("?");
    const q = new URLSearchParams(qs || "");
    if (vc) q.set("vc", vc);
    return `${SHARE_PATHS[path] || path}?${q.toString()}`;
  };
  return {
    client,
    get: (path, config) => client.get(map(path), config),
    download: (url, filename) => downloadFile(map(url), filename, client),
    readOnly: true,
    logoUrl: (c) => (c.has_logo ? `${process.env.REACT_APP_BACKEND_URL}/api/share/${lid}/logo?company=${c.id}&variant=light&v=${c.logo_version}` : null),
    canExport: info.allow_exports,
    bounds: info.date.from ? [info.date.from, info.date.to] : null,
    excluded: info.excluded_lines,
    note: info.note,
    visible: (k) => info.tabs.includes(k),
  };
}

export const SourceContext = createContext(adminSource);
export const useSource = () => useContext(SourceContext);
